import { bool, string } from 'prop-types';
import React from 'react';

import styles from './tag.module.css';

const Tag = ({ inverse, text }) =>
  <div className={`${styles.tag} ${inverse ? styles.inverse : ''}`}>{text}</div>;

Tag.propTypes = {
  text: string.isRequired,
  inverse: bool
};

Tag.defaultProps = {
  inverse: false
};

export default Tag;
